import { Injectable } from '@angular/core';
import { AngularFire } from 'angularfire2';
import { Page, Promotion } from '../models';
import 'rxjs/add/operator/map';
import { FirebaseService } from './firebase.service';

@Injectable()
export class PromotionService extends FirebaseService {
  promotions: Promotion[] = [];

  constructor(protected _af: AngularFire) {
    super();
    this.firebaseType = 'ads';
   }

  mapObjJson(jsonAds: any[]): Promotion[] {
    let promotions = jsonAds.map((promotion) => new Promotion(promotion));
    this.promotions.length = 0;
    [].push.apply(this.promotions, promotions);
    this.updatePromotionsWithPages();

    return this.promotions;
  }

  getPromotionObjectByUrl(url: string) {
    let promotions = this.promotions.slice();
    for (let i = 0; i < promotions.length; i++) {
      if (promotions[i].firebaseUrl === url) return promotions[i];
    }
  }

  getPromotionByUrl(firebaseUrl: string) {
    return this._af.database.object(this.firebaseRoot + '/ads' + firebaseUrl)
    .map(jsonPromotion => {
      jsonPromotion.firebaseUrl = firebaseUrl;
      let promotion = new Promotion(jsonPromotion);
      this.updatePromotionWithPage(promotion);
      return promotion;
    });
  }

    // Called when pages or pods are updated
  updatePromotionsWithPages(pages?: Page[]) {
    if (!pages) pages = this.pages;
    this.pages = pages;
    this.promotions.forEach(promotion => {
      this.updatePromotionWithPage(promotion);
    });
  }

  updatePromotionWithPage(promotion: Promotion) {
    let triggerPage = this.pages.filter(page => page.id === promotion.triggerID);
    let targetPage = this.pages.filter(page => page.id === promotion.targetID);
    if (triggerPage.length) promotion.triggerPage = triggerPage[0];
    else promotion.triggerPage = null;
    if (targetPage.length) promotion.targetPage = targetPage[0];
    else promotion.targetPage = null;
  }

  updatePromotionsWithDeletedPage(deletedPage: Page) {
    let promotions = this.promotions.slice();
    let firebaseList = [];
    promotions.forEach(promotion => {
      if (promotion.triggerPage && promotion.triggerPage.id === deletedPage.id) {
        promotion.status = 'hidden';
        promotion.triggerID = null;
        promotion.triggerPage = null;
      }
      if (promotion.targetPage && promotion.targetPage.id === deletedPage.id) {
        promotion.targetID = null;
        promotion.targetPage = null;
      }
      firebaseList.push(promotion.toFirebaseObject());
    });

    return this._af.database.object(this.firebaseRoot).update({ ads: firebaseList });
  }

  updatePromotionPositions(childUrl: string, newType: string, newPosition: number) {
    let promotions = this.promotions.slice();
    let child = this.getPromotionObjectByUrl(childUrl);
    child.status = newType.toLowerCase();
    promotions.splice(promotions.indexOf(child), 1);
    promotions.splice(newPosition, 0, child);

    let firebaseList = [];
    for (let i = 0; i < promotions.length; i++) {
      firebaseList.push(promotions[i].toFirebaseObject());
    }
    return this._af.database.object(this.firebaseRoot).update({ ads: firebaseList });
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/services/app/content/helpers/promotion.service.ts